<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <!-- <app-drop-down-single-select
                  [DropDownOptions]="dropdownListStatus"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'status'"
                ></app-drop-down-single-select> -->
                <app-drop-down
                  type="status"
                  [settings]="dropdownSettingsBookType"
                  [list]="dropdownListStatus"
                  (dropDownChanged)="updateSelectedType($event)"
                  [selectedItems]="selectedDefaultItemsStatus"
                ></app-drop-down>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">ISBN-10E</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">Product ID</th>
          <th scope="col">Title Category</th>
          <th scope="col">Title</th>
          <th scope="col">Status</th>
          <th scope="col">AE</th>
          <th scope="col">AM</th>
          <th scope="col">Publisher</th>
          <th scope="col">Commit Date</th>
          <th scope="col">Published Date</th>
          <th scope="col">Website Category</th>
          <th scope="col">commercial Priority</th>
          <th scope="col">Authors Name</th>
          <th scope="col">Email Address</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.isbn_10e}}</td>
          <td>{{product.isbn_10}}</td>
          <td>{{product.isbn_13e}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.part_number}}</td>
          <td>{{product.title_category}}</td>
          <td>{{product.name}}</td>
          <td>{{product.product_status}}</td>
          <td>{{product.AE}}</td>
          <td>{{product.AM}}</td>
          <td>{{product.Publisher}}</td>
          <td>{{product.commit_date}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.website_category}}</td>
          <td>{{product.commercial_priority}}</td>
          <td>{{product.author_names}}</td>
          <td>{{product.email_addresses}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
